import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ErrorDialogComponent } from '../error-dialog/error-dialog.component';

@Component({
  selector: 'app-reject-order',
  templateUrl: './reject-dialog.component.html'
})
export class RejectDialogComponent implements OnInit {
  @ViewChild('myFirstFocus') myFirstFocus: ElementRef;

  comment = '';
  selectedReason: string = '';
  otherReasonText: string = '';
  showOtherInput = false;
  reasons = [
    'Too expensive',
    'Takes too long',
    'Already assigned to another vendor',
    'No Longer Needed',
    'Other'
  ];

  constructor(
    public dialogRef: MatDialogRef<RejectDialogComponent>,
    private matDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.myFirstFocus?.nativeElement?.focus();
    });
  }

  onReasonChange() {
    this.showOtherInput = this.selectedReason === 'Other';
    if (!this.showOtherInput) this.otherReasonText = '';
  }

  confirm(): void {
    if (this.showOtherInput && !this.otherReasonText.trim()) return;

    this.dialogRef.close({
      state: true,
      reason: this.showOtherInput ? this.otherReasonText.trim() : this.selectedReason
    });
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  isInvalid(): boolean {
    return !this.selectedReason || (this.showOtherInput && !this.otherReasonText.trim());
  }

  openErrorPopup(msg: string) {
    this.matDialog.open(ErrorDialogComponent, {
      data: { message: msg }
    });
  }
}
